import { RecurringInvoiceRepository } from "../domain/RecurringInvoiceRepository";
import { RecurringInvoiceContract } from "../domain/RecurringInvoiceContract";
import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";
import { query_dispatcher, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";
import { ApiInvoiceableRepository, objectToDict } from "./ApiInvoiceableRepository";
import { RecInv } from "../domain/Invoiceable";

export class ApiRecurringInvoiceRepository implements RecurringInvoiceRepository {

    query_dispatcher: any
    sync_command_dispatcher: CommandDispatcher
    async_command_dispatcher: CommandDispatcher
    invoiceable_repository: any

    constructor() {
        this.query_dispatcher = query_dispatcher
        this.sync_command_dispatcher = sync_command_dispatcher
        this.async_command_dispatcher = async_command_dispatcher
        this.invoiceable_repository = new ApiInvoiceableRepository()
    }

    api_to_domain(data: any): RecurringInvoiceContract {
        let invoice = this.invoiceable_repository.api_to_domain(data.invoice)

        return new RecurringInvoiceContract(
            data.id,
            data.duration,
            data.start_date,
            data.end_date,
            data.expiration,
            data.create_auto,
            data.send_auto,
            data.interval,
            data.period,
            data.state,
            invoice
        );
    }

    domain_to_api(recurringInvoice: RecurringInvoiceContract): any {
        let data = JSON.parse(JSON.stringify(objectToDict(recurringInvoice)));
        delete data['invoice']
        data['invoice'] = this.invoiceable_repository.domain_to_api(recurringInvoice.invoice)
        return data
    }
    

    async find_by_id(id: any): Promise<RecurringInvoiceContract | null> {
        let res = await this.query_dispatcher.dispatch('get.recurring.invoice', {inv_id: id})
        if (res)
            return this.api_to_domain(res)
        return null
    }

    async filter_recurring_invoices(args: any): Promise<{ results: RecurringInvoiceContract[]; count: number; }> {
        return await this.query_dispatcher.dispatch('get.recurring.invoices', args)
    }

    async save(recurringInvoice: RecurringInvoiceContract): Promise<any> {
        let data = this.domain_to_api(recurringInvoice)
        let res = await this.sync_command_dispatcher.dispatch('save.recurring.invoice.contract', {recurring_invoice_contract: data})
        return res['output']['id']
    }

    createEmptyRecurringInvoice(company_id, currentCompany, tax_type = 'iva'): RecurringInvoiceContract {
        let invoice = this.invoiceable_repository.create_empty_invoiceable(company_id, currentCompany, null, null, tax_type, 'recurring_invoice_contract')
        let today_date = new Date().toISOString().split('T')[0]
        let recurring_invoice = new RecurringInvoiceContract(null, null, today_date)
        recurring_invoice.invoice = invoice as RecInv
        return recurring_invoice
    }

    async createinvoiceFromContract(id: number): Promise<any> {
        let res = await this.async_command_dispatcher.dispatch('force.create.invoice.from.contract', {recurring_invoice_contract_id: id})
        return res['output']
    }

    async delete(ids: Array<number>): Promise<any> {
        let res = await this.sync_command_dispatcher.dispatch('delete.recurring.invoice.contracts', {ids: ids})
        return res['output']
    }

    async startStopRecurringInvoice(id: number, start: boolean): Promise<any> {
        return await this.sync_command_dispatcher.dispatch('start.stop.recurring.invoice.contract', {inv_id: id, start: start})
    }

    async getNextInvoiceInfo(id: number, interval:string, start_date:string): Promise<any> {
        return await this.query_dispatcher.dispatch('get.next.contract.invoice.info', {inv_id: id, interval: interval, start_date: start_date})
    }
    
    async import_recurring_invoice_from_excel(path:string, company_id:number): Promise<any> {
        return await this.sync_command_dispatcher.dispatch('import.recurring.invoices.from.excel', { excel_path: path, company_id: company_id })
    }
    
    async adjust_bases_by_percent(rec_contract_ids: Array<Number>, adjustPercent: number): Promise<any> {
        const args = {
            rec_contract_ids: rec_contract_ids,
            adjust_value: adjustPercent,
            adjust_type: 'percent'
        }
        let res = await this.async_command_dispatcher.dispatch_with_result('massive.adjust.bases', args)
        return res
    }

    async adjust_bases_by_fixed(rec_contract_ids: Array<Number>, adjustValue: number): Promise<any> {
        const args = {
            rec_contract_ids: rec_contract_ids,
            adjust_value: adjustValue,
            adjust_type: 'fixed'
        }
        let res = await this.async_command_dispatcher.dispatch_with_result('massive.adjust.bases', args)
        return res
    }
}
